var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing #04 [Desktop] // Hero of Landing Page 2",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "div.w-layout-grid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "div#w-node-_71b95c26-9ea9-e432-415e-b865ca92fd7e-6c7bb083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Link"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -143,
    y: -26.2168,
    width: 205.41,
    height: 64,
    rx: 3,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "613d5c4dc4abb846b5d44c3c_cta-arrow-white.svg",
    opacity: 0.45,
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "613d5c4dc4abb846b5d44c3c_cta-arrow-white.svg fill",
    clipPath: "url(#clip2_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "613d5c4dc4abb846b5d44c3c_cta-arrow-white.svg_2",
    clipPath: "url(#clip3_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.41016 6.03322C0.995941 6.03322 0.660156 6.36902 0.660156 6.78322C0.660156 7.19742 0.995941 7.53322 1.41016 7.53322V6.03322ZM16.9405 7.31357C17.2334 7.02067 17.2334 6.54577 16.9405 6.25287L12.1675 1.47992C11.8746 1.18703 11.3998 1.18703 11.1069 1.47992C10.814 1.77282 10.814 2.24769 11.1069 2.54058L15.3495 6.78322L11.1069 11.0259C10.814 11.3188 10.814 11.7936 11.1069 12.0865C11.3998 12.3794 11.8746 12.3794 12.1675 12.0865L16.9405 7.31357ZM1.41016 7.53322H16.4102V6.03322H1.41016V7.53322Z",
    fill: "white"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaArrowWhite);
export default __webpack_public_path__ + "static/media/cta-arrow-white.6a923858047914beb94e2cf8c7833067.svg";
export { ForwardRef as ReactComponent };